<template>
  <div class="navbar">
    <!--    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />-->

    <div class="right-menu">
      <div class="downLoad-center-item" @click="showDownLoadCenterModal">
        <img src="../../assets/icon_down.png" alt="" />
        下载中心
      </div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="../../assets/user.png" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
          <span class="user-lever">{{ $store.getters.name }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- <router-link to="/">
            <el-dropdown-item>
              Home
            </el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登陆</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <downloadCenterModal
      :visible.sync="downloadCenterModalVisible"
    ></downloadCenterModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import downloadCenterModal from "./download-center.vue";

export default {
  components: {
    Hamburger,
    downloadCenterModal,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  data() {
    return {
      downloadCenterModalVisible: false,
    };
  },
  created() {},
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$store.state.permission.addRouters = [];
      await this.$store.dispatch("user/resetToken");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    showDownLoadCenterModal() {
      this.downloadCenterModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 74px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 74px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    // float: right;
    margin: 0 20px;
    height: 100%;
    line-height: 85px;
    display: flex;
    justify-content: end;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      display: flex;
      align-items: center;
      justify-content: end;
      width: 100px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        margin-right: 10px;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          position: absolute;
          top: -28px;
          right: 36px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -24px;
          top: -12px;
          font-size: 12px;
        }

        .user-lever {
          position: absolute;
          width: 50px;
          top: -48px;
          right: -17px;
          cursor: pointer;
        }
      }
    }
  }
  .downLoad-center-item {
    display: flex;
    justify-items: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    color: #00b882;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue